module.exports = __webpack_public_path__ + "static/media/siddharth-dosa.0a6f1bdf.jpg";